import { ReactNode } from "react"
import TableHead from "components/Core/Table/TableHead"
import TableHeadCell from "components/Core/Table/TableHeadCell"
import TableBody from "components/Core/Table/TableBody"
import TableRow from "components/Core/Table/TableRow"
import TableCell from "components/Core/Table/TableCell"
import { Table as Tab } from "flowbite-react"
import cn from "classnames"

interface ITable {
  children: ReactNode
  className?: string
}

const Table = ({ children, className }: ITable) => {
  return (
    <div className={cn("w-full overflow-x-auto", className)}>
      <Tab hoverable className={className}>{children}</Tab>
    </div>
  )
}

Table.Head = TableHead
Table.HeadCell = TableHeadCell
Table.Body = TableBody
Table.Row = TableRow
Table.Cell = TableCell

export default Table
